import { yupResolver } from '@hookform/resolvers/yup';
import React, { useContext } from 'react';
import { useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import { uid } from 'uid';
import { IoCloseSharp } from 'react-icons/io5';
import { Controller, useForm } from 'react-hook-form';
import * as yup from 'yup';
import axios from 'axios'
import { PropsFromRedux } from '.';
import { API_KEYS } from '../../interfaces/api';
import { USER } from '../../interfaces/auth.interface';
import TextInput from '../form-controls/TextInput';
import Select from '../form-controls/Select';
import { BeatLoader, Spinner } from '../Spinners/Spinner';
import { getRequiredErrorMessage } from '../../utils/common.utils';

interface Props extends PropsFromRedux {
}

interface Inputs {
    BankName : any;
    AccountNumber: string;
    AccountName : string;
    Amount : number;
  }

  const schema = yup.object().shape({
    BankName: yup
    .object()
    .shape({
      IsActive: yup.boolean(),
      name: yup.string(),
      code: yup.string(),
    })
    .required(getRequiredErrorMessage('Bank Name'))
    .typeError('Select Bank'),
    Amount: yup.number()
    .required(getRequiredErrorMessage('Amount'))
    .typeError('Amount is required'),
    AccountNumber: yup.string()
    .required(getRequiredErrorMessage('Account Number'))
    .min(10, 'Invalid account number length')
    .max(10, 'Invalid account number length'),
    AccountName: yup.string().required(getRequiredErrorMessage('Account Name'))
  });


  const Withdraw: React.FC<Props> = ({
    showModal,
    hideModal,
    getBanks,
    getBankState,
    validateBankDetails,
    bankValidationState,
    walletPinState,
    getWalletPinStatus,
    resetApi
  }) => {
  

    const closeModal = () => {
        hideModal();
    };

    React.useEffect(
      () => () => {
        resetApi(API_KEYS.GET_COD_BANKS);
        resetApi(API_KEYS.VALIDATE_BANK);
        resetApi(API_KEYS.GET_WALLETPIN_STATUS);
      },
      [resetApi]
    );

    const [bankList, setBankList] = React.useState([]);
    const [accountName, setAccountName] = React.useState('');
    
    const history = useHistory();
    
    const onSubmit = (data: Inputs) => {
      resetApi(API_KEYS.GET_WALLETPIN_STATUS);
      // console.log(data);
      if(walletPinState?.response?.Object === false){
          showModal({
                component: 'WalletPinModal',
                modalProps: {
                contentLabel: 'Wallet Pin Modal',
              },
          });
      }
      else {
        hideModal();
        showModal({
          component: 'ConfirmTransactionPinCod',
          modalProps: {
            contentLabel: 'Confirm Transaction Modal',
          },
          ownProps: {
            withdrawData: data
          }
        });
      }
    }

    React.useEffect(() => {
        getBanks();
        resetApi(API_KEYS.VALIDATE_BANK);
      }, [getBanks, resetApi]);

      // console.log('Bank validation state',bankValidationState);

      React.useEffect(() => {
        if (getBankState?.success && getBankState?.response?.Object) {
            setBankList(getBankState?.response?.Object?.data)
           }
   }, [getBankState?.success, getBankState?.response?.Object, setBankList]);



   React.useEffect(() => {
     if(!bankValidationState?.loading && accountNo && accountNo.length === 10 && bankCode){
      if (bankValidationState?.success && bankValidationState?.response?.Object?.status == true) {
        setValue('AccountName', bankValidationState?.response?.Object?.data?.name);
         }
     }
}, [!bankValidationState?.loading, bankValidationState?.success, bankValidationState?.response?.Object?.status == true, bankValidationState?.response?.Object?.data?.name]);


    const { handleSubmit, control, errors, reset, watch,register, setValue } = useForm<Inputs>({
        resolver: yupResolver(schema),
        defaultValues : {
          AccountName : ""
        }
    });

    const accountNo : any = watch('AccountNumber');
    const bankCode : any = watch('BankName');

    React.useEffect(() => {
      if(accountNo && accountNo.length === 10 && bankCode){
        validateBankDetails({
            accountNumber : accountNo,
            bankCode : bankCode.code
          })
      }
    }, [validateBankDetails, accountNo, bankCode]);

    // if (getBankState?.loading || bankValidationState?.loading)  {
    //   return (
    //     <div className="w-full flex items-center justify-center pt-4 overflow-hidden">
    //       <Spinner />
    //      </div>
    //   );
    // }

    return(
        <form className="w-full" onSubmit={handleSubmit(onSubmit)}>
          <div className="w-full bg-white lg:px-10 py-10 relative">
                <button type="button" aria-label="Close" onClick={closeModal}>
                    <IoCloseSharp className="sticky sm:absolute cursor-pointer text-2xl top-0 left-full sm:left-auto sm:right-5 sm:top-5" />
                </button>
                {getBankState?.loading || bankValidationState?.loading &&  <Spinner />}
                <h2 className="font-semibold mb-4 text-3xl text-black text-center my-6 mb-4">Withdraw Fund</h2>
                <p className="text-gray-400 text-sm text-center mb-4">Kindly note that your transaction history will be viewed on the stellas bank app.</p>
                <div className="mb-5 text-sm text-gray-500 font-medium">
                <Controller
                    name="BankName"
                    control={control}
                    defaultValue=""
                    render={({ name, value, onChange }) => (
                    <Select
                        name={name}
                        value={value}
                        id={name}
                        wrapperClassName="w-full"
                        valueKey="code"
                        labelKey="name"
                        error={errors['BankName']}
                        label="Bank Name:"
                        labelClassName="mb-2 flex"
                        placeholder="Select Bank"
                        customChange={onChange}
                        className="rounded-md"
                        options={bankList}
                        noOptionsMessage={() =>
                          getBankState?.loading ? 'Loading...' : 'No Bank found'
                        }
                    />
                    )}
                />
              </div>
                <div className="mb-5 text-sm text-gray-500 font-medium">
                <Controller
                    name="AccountNumber"
                    control={control}
                    defaultValue=""
                    render={({ name, value, onChange }) => (
                    <TextInput
                        name={name}
                        value={value}
                        className="border-gray-300 bg-grey-600 border p-3 w-full rounded-md"
                        id={name}
                        labelClassName="mb-2 flex "
                        label="Account Number:"
                        type="string"
                        wrapperClassName="w-full bg-grey-400"
                        error={errors['AccountNumber']}
                        placeholder="1029138390"
                        customChange={onChange}
                    />
                    )}
                />
              </div>
              
              <div className="mb-5 text-sm text-gray-500 font-medium text-center">
                {bankValidationState?.loading && <BeatLoader color="black" />}
            </div>

          <div className="mb-5 text-sm text-gray-500 font-medium">
          <Controller
                    name="AccountName"
                    control={control}
                    defaultValue=""
                    render={({ name, value, onChange }) => (
                    <TextInput
                        name={name}
                        value={value}
                        className="border-gray-300 border p-3 w-full rounded-md"
                        id={name}
                        labelClassName="mb-2 flex "
                        label="Account Name:"
                        type="string"
                        disabled
                        wrapperClassName="w-full"
                        error={errors['AccountName']}
                        placeholder="Bolarinwa Adebola"
                        customChange={onChange}
                    />
                    )}
                />
            </div>

            <div className="mb-5 text-sm text-gray-500 font-medium">
                    <Controller
                            name="Amount"
                            control={control}
                            defaultValue=""
                            render={({ name, value, onChange }) => (
                            <TextInput
                                name={name}
                                value={value}
                                className="border-gray-300 border p-3 w-full rounded-md"
                                id={name}
                                labelClassName="mb-2 flex "
                                label="Withdrawal Amount:"
                                type="number"
                                wrapperClassName="w-full"
                                error={errors['Amount']}
                                placeholder="10,000"
                                customChange={onChange}
                            />
                            )}
                />
            </div>

          <div className="flex w-full justify-center">
        <button
          className="w-full bg-secondary my-10 font-semibold text-sm rounded text-white py-4"
          type="submit"
          > 
             Withdraw
        </button>
    
        </div>
          </div>
        </form>
    );          
}

export default Withdraw;